import { EntityConnectionAction } from '../../../connections/domain/value-objects/entity-connection-action.vo';
import { EntityCommunicationState } from '../../../connections/domain/value-objects/entity-communication-state.vo';
import { QcCommunicationDocument, QcCommunicationEvent, QcCommunicationHistoryItem } from '../../domain/entities/qc-communication-history.entity';

export interface QcCommunicationDocumentApi {
  id: string;
  name: string | null;
  fileName: string | null;
  size: number | null;
  extension: string | null;
}

export interface QcCommunicationEventApi {
  id: string;
  occurredAt: string;
  isSuccess: boolean;
  response: string | null;
  primaryDocument: QcCommunicationDocumentApi | null;
}

export interface QcCommunicationHistoryItemApi {
  id: string;
  contractId: number;
  qualityControlId: string | null;
  qualityControlVersion: number | null;
  action: number;
  state: number;
  createdAt: string;
  finishedAt: string | null;
  isFinished: boolean;
  isSuccess: boolean | null;
  hasErrors: boolean | null;
  errors: string | null;
  requiresReview: boolean | null;
  reviewComments: string | null;
  events: QcCommunicationEventApi[] | null;
}

export interface QcCommunicationHistoryApiResponse {
  items: QcCommunicationHistoryItemApi[] | null;
}

export class QcCommunicationHistoryMapper {
  static toDocumentDomain(api: QcCommunicationDocumentApi): QcCommunicationDocument {
    return {
      id: api.id,
      name: api.name,
      fileName: api.fileName,
      size: api.size,
      extension: api.extension,
    };
  }

  static toEventDomain(api: QcCommunicationEventApi): QcCommunicationEvent {
    return {
      id: api.id,
      occurredAt: new Date(api.occurredAt),
      isSuccess: api.isSuccess,
      response: api.response,
      primaryDocument: api.primaryDocument
        ? QcCommunicationHistoryMapper.toDocumentDomain(api.primaryDocument)
        : null,
    };
  }

  static toDomain(api: QcCommunicationHistoryItemApi): QcCommunicationHistoryItem {
    return {
      id: api.id,
      contractId: api.contractId,
      qualityControlId: api.qualityControlId,
      qualityControlVersion: api.qualityControlVersion,
      action: api.action as EntityConnectionAction,
      state: api.state as EntityCommunicationState,
      createdAt: new Date(api.createdAt),
      finishedAt: api.finishedAt ? new Date(api.finishedAt) : null,
      isFinished: api.isFinished,
      isSuccess: api.isSuccess,
      hasErrors: api.hasErrors,
      errors: api.errors,
      requiresReview: api.requiresReview,
      reviewComments: api.reviewComments,
      events: (api.events ?? []).map(QcCommunicationHistoryMapper.toEventDomain),
    };
  }
}
